import { useState } from 'react';
import { useForm } from '@moda/portal-stanchions';
import { CONFIG } from '../../config';
import { tc } from '../../lib/trackingContext';
import { getUserFromCookies } from '../../hooks/useUser';

type ContactToPurchaseFormFields = {
  name: string;
  email: string;
  phone: string;
  notes: string;
  'g-recaptcha-response': string;
};

const VALIDATIONS = {
  name: {
    required: {
      message: 'Please enter you name.',
      value: true
    }
  },
  email: {
    email: {
      message: 'Invalid email address.',
      value: true
    },
    required: {
      message: 'Please enter an email address.',
      value: true
    }
  }
};

const { accessToken } = getUserFromCookies();

const submitRequest = ({
  name,
  email,
  phone,
  notes,
  'g-recaptcha-response': gCaptchaResponse
}: ContactToPurchaseFormFields): Promise<{ success: boolean }> =>
  fetch(`${CONFIG.MODA_API_URL}/v3.5/booking_required`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: accessToken ? `Bearer ${accessToken}` : ''
    },
    body: JSON.stringify({
      name,
      email,
      phone,
      notes,
      g_recaptcha_response: gCaptchaResponse,
      product_path: `${CONFIG.DISCOVERY_API_URL}${location.pathname}`
    })
  }).then(response => (response.ok ? response.json() : { success: false }));

export const useContactToPurchaseForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values: ContactToPurchaseFormFields) => {
    setError(null);
    setLoading(true);

    try {
      const newValues = { ...values, gRecaptchaResponse: values['g-recaptcha-response'] };
      const { success } = await submitRequest(newValues);
      if (!success) throw new Error();
      if (success) {
        tc.track('Contact To Purchase Submitted', {
          addToTrackingEvent: {
            label: 'Submit',
            form_location: location.pathname
          }
        });
      }
      onSuccess();
    } catch {
      setError(new Error('Unable to send your request at this time.'));
    }

    setLoading(false);
  };

  const { errors: formErrors, handleSubmit } = useForm({ validations: VALIDATIONS, onSubmit });
  return { handleSubmit, formErrors, error, loading };
};
